"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function accumulateElement(children, element) {
  if (!children) {
    return typeof element === 'function' ? element(null) : element;
  }
  if (!element) {
    return children;
  }
  if (! /*#__PURE__*/_react.default.isValidElement(children)) {
    // Children come from named child routes.
    const groups = {};
    Object.entries(children).forEach(([groupName, groupElements]) => {
      groups[groupName] = groupElements.reduceRight(accumulateElement, null);
    });
    return typeof element === 'function' ? element(groups) : /*#__PURE__*/_react.default.cloneElement(element, groups);
  }
  return typeof element === 'function' ? element(children) : /*#__PURE__*/_react.default.cloneElement(element, {
    children
  });
}
function ElementsRenderer({
  elements
}) {
  return elements.reduceRight(accumulateElement, null);
}
var _default = ElementsRenderer;
exports.default = _default;
module.exports = exports.default;